import { PipeTransform } from '@angular/core';
var RemoveTimeSecondsPipe = /** @class */ (function () {
    function RemoveTimeSecondsPipe() {
    }
    RemoveTimeSecondsPipe.prototype.transform = function (date) {
        if (!date) {
            return;
        }
        var splitedDate = date.split(':');
        if (splitedDate.length !== 3) {
            return date;
        }
        return splitedDate.slice(0, splitedDate.length - 1).join(':');
    };
    return RemoveTimeSecondsPipe;
}());
export { RemoveTimeSecondsPipe };
